import api from '@/services/Api';

export default {
  uploadSiteLinkThumbnail(file) {
    const formData = new FormData();
    formData.append('image', file);

    return api().post('/file/upload/site-link-thumbnail', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
